import ruMessages from '../locales/ru_RU.json';
import merchandisingMessages from '../locales/merchandising';

const RuLang = {
  messages: {
    ...merchandisingMessages,
    ...ruMessages,
  },
  locale: 'ru-RU',
};

export default RuLang;
